import { AppThunk } from '../../../store/rootReducer';
import { primaryAbnormalitiesSelector } from '../selectors/user-diagnostic.selectors';
import { Abnormality } from '../types/diagnostic';
import * as diagnosticActions from '../actions/diagnostic.actions';
import { uniqBy } from 'lodash';

export const saveManualAbnormalities =
  (manualAbnormalities: Abnormality[]): AppThunk =>
  async (dispatch, getState) => {
    const primaryAbnormalities = primaryAbnormalitiesSelector(getState());
    // we remove primary abnormalities that may exist on both the copied diagnostic and the user's
    // abnormalities, after the concatenation
    const abnormalities = uniqBy(
      primaryAbnormalities.concat(manualAbnormalities),
      'code',
    );

    dispatch(
      diagnosticActions.setAbnormalities({
        abnormalities,
      }),
    );
  };
